import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { RefundEntity } from "domain/entity/Refund/RefundEntity";
import { RefundOperationCriteria } from "domain/entity/Refund/RefundOperationCriteria";
import { RefundSearchCriteria } from "domain/entity/Refund/RefundSearchCriteria";
import { axiosPostData } from "../axios/AxiosBasicImpl";
import collectionAxiosInstance from "../axios/collectionAxiosInstance";
import { RefundRepository } from "./RefundRepo";

export const RefundRepoImpl = (): RefundRepository => {

    const onSearch = async (criteria: RefundSearchCriteria): Promise<RefundEntity[]> => {
        const url = '/v1/refund';
        return axiosPostData(collectionAxiosInstance, url, criteria).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const onSave = async (entity: RefundEntity): Promise<ResponseEntity> => {
        const url = '/v1/saveRefund';
        return await axiosPostData(collectionAxiosInstance, url, entity);
    }

    const onOperation = async (criteria: RefundOperationCriteria): Promise<ResponseEntity> => {
        const url = '/v1/operationRefund';
        return await axiosPostData(collectionAxiosInstance, url, criteria);
    }


    return {
        onSearch: onSearch,
        onSave: onSave,
        onOperation: onOperation,
    }
}